import { useEffect, useState } from "react";
import { Eye, EyeOff, AlertCircle } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
// import { path } from '../Utils/ScreenPath';
import desktop from "../../assets/desktop.png";
import login from "../../assets/login.png";
import desktopmo from "../../assets/desktopmo.png";

import { Image } from "lucide";
import { path } from "../../Utils/ScreenPath";
import { useDispatch, useSelector } from "react-redux";
import { ACTIONS } from "../../redux/actions";
import { toast } from "react-toastify";
import { ErrorToast, SuccessToast } from "../../Utils/toast";
import { API } from "../../Common/Api";
import Loading from "../../Common/Loading";
import { validateMobile, handleMobileChange, isMobileValidForSubmission, validateMobileComplete, getMobileInputProps } from "../../Utils/mobileValidation";

export default function LoginForm() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const Login = useSelector((state) => state.Login?.LoginData);
  const SendOtpResponse = useSelector((state) => state.SendOtp?.SendOtpData);

  const [loginMethod, setLoginMethod] = useState("otp");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [timer, setTimer] = useState(60);
  const [checkLogin, setCheckLogin] = useState(false);
  const [isOtpSentRequested, setIsOtpSentRequested] = useState(false);
  const [apiError, setApiError] = useState("");

  // Forgot password (distributor) modal
  const [forgotOpen, setForgotOpen] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotError, setForgotError] = useState("");
  const [forgotLoading, setForgotLoading] = useState(false);

  const handleForgotSubmit = async () => {
    setForgotError("");
    if (!forgotEmail) {
      setForgotError("Email is required");
      return;
    }
    if (!validateEmail(forgotEmail)) {
      setForgotError("Please enter a valid email");
      return;
    }
    setForgotLoading(true);
    try {
      const res = await API.ForgotPassword(JSON.stringify({ email: forgotEmail }));
      if (res?.success) {
        SuccessToast(res.message || "If an account exists, a reset link has been sent.");
        setForgotOpen(false);
        setForgotEmail("");
      } else {
        setForgotError(res?.message || "Failed to send reset link.");
      }
    } catch (e) {
      setForgotError("Something went wrong. Please try again.");
    } finally {
      setForgotLoading(false);
    }
  };

  const isOtpMethod = loginMethod === "otp"

  useEffect(() => {
    if (apiError) setApiError("");
  }, [email, mobile, password, otp]);


  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  useEffect(() => {
    dispatch(ACTIONS.clearLogin());
  }, [])

  const navigateByRole = (role) => {
    if (role === "admin") {
      navigate(path.dashboardadmin);
    } else if (role === "distributor" || role === "dealer") {
      navigate(path.dashboard);
    } else if (role === "agent") {
      navigate(path.dashboardagent);
    } else {
      navigate(path.dashboard);
    }
  };

  useEffect(() => {
    if (checkLogin) {
      if (Login?.status == 200 && Login?.success) {
        localStorage.setItem("token", Login?.data?.token);
        localStorage.setItem("UserDetail", JSON.stringify(Login?.data));
        SuccessToast(Login?.message);
        navigateByRole(Login?.data?.role);
      } else {
        setApiError(Login?.message || "Invalid credentials");
      }
      setLoading(false);
    }
  }, [Login])

  useEffect(() => {
    if (isOtpSentRequested && SendOtpResponse) {

      if (SendOtpResponse?.status === 200 && SendOtpResponse?.success) {
        setOtpSent(true);
        setTimer(60);
        // SuccessToast('OTP sent successfully!');
      } else {
        setApiError(SendOtpResponse?.message || 'Failed to send OTP');
      }
      setLoading(false);
      setIsOtpSentRequested(false); // Reset guard
    }
  }, [SendOtpResponse, isOtpSentRequested])

  useEffect(() => {
    let interval;
    if (otpSent && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [otpSent, timer]);


  const validateForm = () => {
    const newErrors = {};

    if (isOtpMethod) {
      // Use comprehensive mobile validation (both input and value)
      const validationResult = validateMobileComplete(mobile, "Mobile Number", true);
      if (!validationResult.isValid) {
        newErrors.email = validationResult.errorMessage;
      }

      if (otp.join("").length < 6) {
        newErrors.otp = "Please enter complete 6-digit OTP";
      }
    } else {
      if (!email) {
        newErrors.email = "Email is required";
      } else if (!validateEmail(email)) {
        newErrors.email = "Please enter a valid Email";
      }

      if (!password) {
        newErrors.password = "Password is required";
      }

    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleLogin = async (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (validateForm()) {
      setLoading(true);

      if (isOtpMethod) {
        let params = {
          mobileNo: mobile,
          otp: otp.join("")
        }



        const response = await API.LoginWithOtp(JSON.stringify(params));



        if (response.status === 200 && response.success) {
          localStorage.setItem("token", response?.data?.token);
          localStorage.setItem("UserDetail", JSON.stringify(response?.data));
          SuccessToast(response?.message);
          navigateByRole(response?.data?.role);
        } else {
          // Handle error
          setApiError(response.message || "Something went wrong");
        }
        setLoading(false);

        return

      }
      const params = {
        email: email.trim().toLowerCase(),
        password: password
      }


      setCheckLogin(true)
      dispatch(ACTIONS.LoginAction(JSON.stringify(params)));


    }
  };

  const handleSendOtp = () => {
    // Use standardized mobile validation
    if (isMobileValidForSubmission(mobile)) {
      setLoading(true);
      setIsOtpSentRequested(true);
      setApiError("");
      const params = {
        mobileNo: mobile
      };
      dispatch(ACTIONS.SendOtpAction(JSON.stringify(params)));
      setErrors({
        ...errors,
        email: "",
      });
    } else {
      const mobileValidationError = validateMobile(mobile, true);
      setErrors({
        ...errors,
        email: mobileValidationError || "Please enter a valid mobile number to receive OTP",
      });
    }
  };

  const toggleLoginMethod = () => {
    setLoginMethod(loginMethod === "password" ? "otp" : "password");
    setErrors({});
    setApiError("");
  };

  return (
    <div className="flex flex-col md:flex-row md:h-screen w-screen overflow-hidden">
      {/* Left side with branding */}
      <div className="w-full md:flex md:w-[85%] md:h-screen md:bg-[#FBFBFC] shadow-[0_14px_42px_rgba(8,15,52,0.1)]">
        <img
          src={desktop}
          alt="Desktop"
          className="hidden md:block w-full h-full object-stretch"
        />
        <img
          src={desktopmo}
          alt="Desktop"
          className="w-full h-[180px] md:h-[250px] object-stretch block md:hidden mt-4"
        />
      </div>

      {/* Right side with login form */}
      <div className="w-full flex-1 md:flex-initial flex justify-center items-stretch md:items-center bg-[#FBFBFC] md:px-0 md:py-0 md:min-h-0">
        <div className={`bg-[#FFFFFF] md:rounded-[30px] p-[16px] md:p-[20px] pb-[24px] md:pb-[20px] w-full md:w-[470px] md:max-w-[470px] md:min-h-[499px] flex flex-col md:shadow-[0px_14px_42px_0px_#080F340F] transition-all duration-300`}>

          <div className={`hidden md:flex justify-left ${apiError ? 'mb-2' : 'mb-6'} transition-all duration-300`}>
            <img src={login} alt="Desktop" />
          </div>

          <h2 className={`text-[18px] md:text-[20px] font-bold text-left ${apiError ? 'mb-2' : 'mb-4 md:mb-6'} transition-all duration-300`}>Login UAT</h2>

          {apiError && (
            <div className="mb-4 flex items-center gap-3 p-3 bg-red-50 border border-red-200 rounded-lg animate-in fade-in animate-shake duration-300">
              <AlertCircle className="h-5 w-5 text-red-500 shrink-0" />
              <p className="text-sm font-medium text-red-700">{apiError}</p>
            </div>
          )}

          <form onSubmit={handleLogin} className="space-y-3 md:space-y-4 flex flex-col flex-1">
            <div className="mb-3 md:mb-4">
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                {isOtpMethod ? "Mobile Number" : "Email"}*
              </label>
              {isOtpMethod ? (
                <input
                  {...getMobileInputProps(mobile, setMobile, setMobileError, true, true, true)}
                  id="email"
                  className={`w-full px-3 md:px-[20px] py-2 md:py-3 border text-sm md:text-base ${errors.email ? "border-red-500" : "border-gray-300"
                    } rounded-md focus:outline-red-400 transition-colors duration-200`}
                />
              ) : (
                <input
                  type="email"
                  id="email"
                  className={`w-full px-3 md:px-[20px] py-2 md:py-3 border text-sm md:text-base ${errors.email ? "border-red-500" : "border-gray-300"
                    } rounded-md focus:outline-red-400 transition-colors duration-200`}
                  placeholder="Enter here"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setApiError("");
                    if (!validateEmail(e.target.value)) {
                      setErrors((prev) => ({ ...prev, email: "Invalid email" }));
                    }
                    else {
                      setErrors((prev) => ({ ...prev, email: "" }));
                    }
                  }}
                />
              )}

              {errors.email && (
                <p className="mt-1 text-sm text-red-500">{errors.email}</p>
              )}
              <div className="mb-1">
                <span className="text-sm text-gray-400">Login</span>
                <span onClick={toggleLoginMethod} className="text-sm text-gray-400 hover:text-gray-900 cursor-pointer font-bold font-style-non">
                  {isOtpMethod ? " with Email ID" : " with otp"}
                </span>
              </div>
            </div>

            {isOtpMethod ? (

              <div className="mb-4">
                <label
                  htmlFor="otp"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  OTP*
                </label>

                {/* Desktop: Flex layout with inline Send OTP button */}
                <div className="hidden md:flex gap-2 mb-3">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      type="text"
                      disabled={!otpSent}
                      className={`w-12 h-12 text-center border ${errors.otp ? "border-red-500" : "border-gray-300"
                        } rounded-md focus:outline-none focus:ring-1 focus:ring-red-500 text-lg font-semibold`}
                      value={digit}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, "");
                        if (value.length <= 1) {
                          const newOtp = [...otp];
                          newOtp[index] = value;
                          setOtp(newOtp);
                          setApiError("");

                          // Auto-focus next input
                          if (value && index < 5) {
                            const nextInput = document.getElementById(`otp-${index + 1}`);
                            if (nextInput) nextInput.focus();
                          }
                        }
                      }}
                      onKeyDown={(e) => {
                        // Handle backspace to go to previous input
                        if (e.key === 'Backspace' && !otp[index] && index > 0) {
                          const prevInput = document.getElementById(`otp-${index - 1}`);
                          if (prevInput) prevInput.focus();
                        }
                      }}
                      onPaste={(e) => {
                        e.preventDefault();
                        const pastedData = e.clipboardData.getData('text').replace(/[^0-9]/g, '').substring(0, 6);
                        if (pastedData) {
                          const newOtp = [...otp];
                          for (let i = 0; i < pastedData.length && i < 6; i++) {
                            newOtp[i] = pastedData[i];
                          }
                          setOtp(newOtp);

                          // Focus the next empty input or the last input
                          const nextEmptyIndex = newOtp.findIndex(digit => !digit);
                          const focusIndex = nextEmptyIndex !== -1 ? nextEmptyIndex : Math.min(pastedData.length, 5);
                          const inputToFocus = document.getElementById(`otp-${focusIndex}`);
                          if (inputToFocus) inputToFocus.focus();
                        }
                      }}
                      id={`otp-${index}`}
                      maxLength={1}
                    />
                  ))}
                  <div className={otpSent && timer > 0 ? "" : "ml-auto"}>
                    <button
                      type="button"
                      disabled={loading || (otpSent && timer > 0)}
                      className={`px-4 py-1 rounded-md text-sm font-medium transition-all duration-200 ${loading || (otpSent && timer > 0)
                        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                        : "bg-red-500 text-white hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 cursor-pointer"
                        }`}
                      onClick={handleSendOtp}
                    >
                      {otpSent ? "Resend OTP" : "Send OTP"}
                    </button>
                  </div>
                </div>

                {/* Mobile: Send OTP Button First, then Grid Layout */}
                <div className="md:hidden">
                  <div className="mb-3">
                    <button
                      type="button"
                      disabled={loading || (otpSent && timer > 0)}
                      className={`w-full px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 ${loading || (otpSent && timer > 0)
                        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                        : "bg-red-500 text-white hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 cursor-pointer"
                        }`}
                      onClick={handleSendOtp}
                    >
                      {loading ? "Sending..." : otpSent ? "Resend OTP" : "Send OTP"}
                    </button>
                  </div>

                  {/* Mobile OTP Input Grid */}
                  <div className="grid grid-cols-6 gap-2 mb-3">
                    {otp.map((digit, index) => (
                      <input
                        key={`mobile-${index}`}
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        disabled={!otpSent}
                        className={`w-full h-10 text-center border text-sm font-semibold ${errors.otp ? "border-red-500" : "border-gray-300"
                          } ${!otpSent ? "bg-gray-100" : "bg-white"} rounded-md focus:outline-none focus:ring-1 focus:ring-red-500`}
                        value={digit}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9]/g, "");
                          if (value.length <= 1) {
                            const newOtp = [...otp];
                            newOtp[index] = value;
                            setOtp(newOtp);
                            setApiError("");

                            // Auto-focus next input with delay for mobile
                            if (value && index < 5) {
                              setTimeout(() => {
                                const nextInput = document.getElementById(`mobile-otp-${index + 1}`);
                                if (nextInput) {
                                  nextInput.focus();
                                  nextInput.select();
                                }
                              }, 10);
                            }
                          }
                        }}
                        onKeyDown={(e) => {
                          // Handle backspace to go to previous input
                          if (e.key === 'Backspace' && !otp[index] && index > 0) {
                            setTimeout(() => {
                              const prevInput = document.getElementById(`mobile-otp-${index - 1}`);
                              if (prevInput) {
                                prevInput.focus();
                                prevInput.select();
                              }
                            }, 10);
                          }
                          // Handle right arrow key
                          if (e.key === 'ArrowRight' && index < 5) {
                            const nextInput = document.getElementById(`mobile-otp-${index + 1}`);
                            if (nextInput) {
                              nextInput.focus();
                              nextInput.select();
                            }
                          }
                          // Handle left arrow key
                          if (e.key === 'ArrowLeft' && index > 0) {
                            const prevInput = document.getElementById(`mobile-otp-${index - 1}`);
                            if (prevInput) {
                              prevInput.focus();
                              prevInput.select();
                            }
                          }
                        }}
                        onFocus={(e) => {
                          // Select all text when focused (for easier editing)
                          e.target.select();
                        }}
                        onPaste={(e) => {
                          e.preventDefault();
                          const pastedData = e.clipboardData.getData('text').replace(/[^0-9]/g, '').substring(0, 6);
                          if (pastedData) {
                            const newOtp = [...otp];
                            for (let i = 0; i < pastedData.length && i < 6; i++) {
                              newOtp[i] = pastedData[i];
                            }
                            setOtp(newOtp);

                            // Focus the next empty input or the last input
                            setTimeout(() => {
                              const nextEmptyIndex = newOtp.findIndex(digit => !digit);
                              const focusIndex = nextEmptyIndex !== -1 ? nextEmptyIndex : Math.min(pastedData.length, 5);
                              const inputToFocus = document.getElementById(`mobile-otp-${focusIndex}`);
                              if (inputToFocus) {
                                inputToFocus.focus();
                                inputToFocus.select();
                              }
                            }, 10);
                          }
                        }}
                        id={`mobile-otp-${index}`}
                        maxLength={1}
                      />
                    ))}
                  </div>
                </div>

                <div className="flex justify-between items-center">
                  {otpSent && timer > 0 && (
                    <div className="text-sm text-gray-600">
                      <span className="font-medium">Didn't receive OTP? Resend in </span>
                      <span className="font-bold text-red-500">{timer}s</span>
                    </div>
                  )}
                </div>
                {errors.otp && (
                  <p className="mt-1 text-sm text-red-500">{errors.otp}</p>
                )}
                {otpSent && (
                  <p className="mt-1 text-sm text-green-500">
                    OTP sent successfully!
                  </p>
                )}
              </div>
            ) : (
              <div className="mb-4">
                <div className="flex justify-between items-center">
                  <label
                    htmlFor="password"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Password
                  </label>
                </div>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    className={`w-full px-3 py-2 border ${errors.password ? "border-red-500" : "border-gray-300"
                      } rounded-md focus:outline-none focus:ring-1 focus:ring-red-500 px-[20px]`}
                    placeholder="Enter password"
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setApiError("");
                      if (errors.password) {
                        setErrors((prev) => ({ ...prev, password: "" }));
                      }
                    }}
                  />
                  <div
                    className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <EyeOff className="h-5 w-5 text-gray-400 transform rotate-250" />
                    ) : (
                      <Eye className="h-5 w-5 text-gray-400" />
                    )}
                  </div>
                </div>
                {errors.password && (
                  <p className="mt-1 text-sm text-red-500">{errors.password}</p>
                )}

                <div className="mt-2 text-right">
                  <span
                    onClick={() => { setForgotOpen(true); setForgotError(""); setForgotEmail(email || ""); }}
                    className="text-sm text-gray-500 hover:text-red-500 cursor-pointer underline font-medium"
                  >
                    Forgot Password?
                  </span>
                </div>
              </div>
            )}

            <div className="pt-2 mt-auto">
              <button
                disabled={loading}
                type="submit"
                className={`w-full border border-red-500 text-red-500 py-2 px-4 bg-[#EE3B310D] font-bold
                hover:bg-red-500 hover:text-white 
                focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 text-center 
                transition duration-200 ease-in-out rounded-full mb-4 md:mb-0
                ${loading ? "opacity-70 cursor-not-allowed" : "cursor-pointer"}`}
                onClick={!loading ? handleLogin : undefined}
              >
                {loading ? "Processing..." : "Login"}
              </button>
            </div>
          </form>
        </div>
        <div className="fixed bottom-4 right-4 text-gray-400 text-xs font-medium z-50">0.0.2</div>
      </div>

      {/* Forgot Password modal (distributor) */}
      {forgotOpen && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6">
            <div className="flex items-start justify-between mb-4">
              <div>
                <h2 className="text-lg font-semibold text-[#1F1715]">Forgot password</h2>
                <p className="text-sm text-gray-500 mt-1">
                  Enter your registered email and we'll send you a link to reset your password.
                </p>
              </div>
              <button
                onClick={() => setForgotOpen(false)}
                className="text-gray-400 hover:text-red-500 text-xl leading-none"
                aria-label="Close"
              >
                ×
              </button>
            </div>

            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input
              type="email"
              value={forgotEmail}
              onChange={(e) => { setForgotEmail(e.target.value); setForgotError(""); }}
              onKeyDown={(e) => e.key === "Enter" && handleForgotSubmit()}
              placeholder="Enter your email"
              className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-red-500 ${forgotError ? "border-red-500" : "border-gray-300"}`}
            />
            {forgotError && <p className="mt-1 text-sm text-red-500">{forgotError}</p>}

            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() => setForgotOpen(false)}
                className="px-5 py-2 rounded-full text-sm font-medium bg-gray-200 text-gray-700 hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                onClick={handleForgotSubmit}
                disabled={forgotLoading}
                className={`px-5 py-2 rounded-full text-sm font-medium text-white ${forgotLoading ? "bg-gray-400 cursor-not-allowed" : "bg-[#E2231A] hover:bg-[#c41d15]"}`}
              >
                {forgotLoading ? "Sending…" : "Send reset link"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
